import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from '../authentications/authentication.service';
import { UserService } from '../shared/services/user.service';

@Component({
  template: `

    `,
  selector: 'fspro-impersonate',
  standalone: false
})
export class ImpersonateComponent implements OnInit {
  public error = '';

  constructor(
    private route: ActivatedRoute,
    private authentication: AuthenticationService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const email = params['email'];

      firstValueFrom(this.userService.getTokenForUser(email)).then(({ token }) => {
        const impersonationUser = this.authentication.getTokenInfo(token);
        if (!impersonationUser || impersonationUser.email !== email) {
          throw new Error('Invalid impersonation token');
        }

        const cookieOptions = '; path=/; samesite=Lax' + (window.location.protocol === 'https:' ? '; secure' : '');
        document.cookie = AuthenticationService.IMPERSONATION_JWT_TOKEN_COOKIE + '=' + encodeURIComponent(token) + cookieOptions;

        this.authentication._impersonation$.next(token);
        this.authentication.setUser(impersonationUser);
        window.location.replace('/');
      }).catch((error) => {
        console.error(error);
      });

    });
  }
}
